import React, { useRef, useEffect } from 'react';
import styles from './HomePage.module.css'; // <— Note the .module.css file
import travelImage from '../../../src/Assets/travelImage.png';
import pharmaceuticalsImage from '../../../src/Assets/pharmaceuticalsImage.jpeg';
import bankingImage from '../../../src/Assets/bankingImage.jpeg';
import technologyImage from '../../../src/Assets/technologyImage.jpeg';
import userPicture from '../../../src/Assets/userPicture.jpeg';
import { useLayoutEffect, useState } from 'react';
import HeroAnimation from '../HeroAnimation';

const HomePage = () => {

    const [isMobile, setIsMobile] = useState(false);

    useLayoutEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Run once on mount
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const [formData, setFormData] = useState({
        name: '',
        email: '',
        feedback: ''
    });


    const contactRef = useRef(null);

    const scrollToContact = () => {
        if (contactRef.current) {
            contactRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [openSolution, setOpenSolution] = useState(null);

    const [activeIndustryIndex, setActiveIndustryIndex] = useState(0);

    const goToPrevIndustry = () => {
        setActiveIndustryIndex((prevIndex) => (prevIndex - 1 + industries.length) % industries.length);
    };

    const goToNextIndustry = () => {
        setActiveIndustryIndex((prevIndex) => (prevIndex + 1) % industries.length);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };


    const handleSubmit = async () => {
        if (!formData.name || !formData.email || !formData.feedback) {
            alert('Please fill in all fields.');
            return;
        }

        const { name, email, feedback } = formData;
        const cleanPayload = { name, email, feedback };

        try {
            console.log('Clean payload:', cleanPayload);
            const response = await fetch('http://34.27.111.37:8000/langchain/send_mail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cleanPayload)
            });
            console.log('Response:', response);
            if (response.ok) {
                alert('Thanks for reaching out! We’ll get back to you shortly.');
                setFormData({ name: '', email: '', feedback: '' });
            } else {
                alert('Oops! Something went wrong.');
            }
        } catch (error) {
            console.error('Submission Error:', error);
            alert('Server error. Please try again later.');
        }
    };


    const industries = [

        {
            title: "Travel",
            description: "We revolutionize the travel industry with AI-driven solutions that personalize trip planning, dynamically optimize itineraries, and enhance booking experiences for travelers worldwide.",
            kpiTitle: "Booking Conversions",
            kpiValue: "+20%",
            kpiDescription: "Personalized recommendations by our AI Solutions led to a noticeable boost in travel package bookings and customer satisfaction.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2 12H22" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            image: travelImage
        },

        {
            title: "Pharmaceuticals",
            description: "We elevate the pharmaceutical industry with AI solutions that accelerate drug discovery, optimize manufacturing processes, and enhance compliance, ensuring safer and more effective healthcare outcomes.",
            kpiTitle: "Knowledge Management Efficiency",
            kpiValue: "+90%",
            kpiDescription: "All teams—R&D, sales, marketing, and regulatory—have on-demand access to critical product knowledge through our specialized AI solutions. ",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_459_24)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9499 6.95965C20.4016 6.93153 19.8954 6.73469 19.4877 6.41132L15.2838 10.2356C16.3664 11.6978 16.2961 13.6943 15.1151 15.0862L19.1643 19.2901C20.4437 18.4886 22.145 19.4166 22.145 20.9491C22.145 22.0317 21.2733 22.9034 20.1907 22.9034C19.1502 22.9034 18.3067 22.102 18.2364 21.0756L13.9341 20.443C13.2733 21.9052 11.0799 21.4412 11.0799 19.8384C11.0799 19.0089 11.7548 18.348 12.5703 18.348C13.3295 18.348 13.9481 18.9104 14.0466 19.6415L18.3629 20.2742C18.4191 20.1196 18.4894 19.979 18.5738 19.8524L14.5246 15.6486C13.0764 16.7874 11.0237 16.7452 9.60367 15.5642L4.40156 20.6538C5.21703 21.9333 4.30314 23.6486 2.75657 23.6486C1.67397 23.6486 0.788204 22.7769 0.788204 21.6943C0.788204 20.7944 1.40683 20.0352 2.2223 19.8103L2.05358 16.9983C1.11158 16.8577 0.394531 16.0422 0.394531 15.0581C0.394531 13.8067 1.54743 12.8929 2.77063 13.16L4.05007 10.348C1.98328 8.95613 2.96747 5.73645 5.44198 5.73645C6.8339 5.73645 7.97274 6.86123 7.97274 8.25314C7.97274 9.9122 6.38399 11.1073 4.79523 10.6855L3.5158 13.4974C4.82335 14.4676 4.42968 16.5203 2.86905 16.9561L3.03777 19.754C3.33302 19.7962 3.60016 19.9087 3.83917 20.0633L9.04128 14.9878C7.01668 12.4289 8.83038 8.6187 12.1204 8.6187C13.1186 8.6187 14.0466 8.99831 14.7355 9.631L18.9393 5.80675C18.6722 5.37089 18.5176 4.86474 18.5457 4.31641L12.8374 3.09321C11.9798 5.0194 9.09752 4.40077 9.09752 2.30587C9.09752 1.22327 9.96922 0.351562 11.0518 0.351562C12.1344 0.351562 13.0061 1.22327 13.0061 2.30587L18.7144 3.51501C19.0799 2.58706 19.9938 1.92626 21.0624 1.92626C22.4543 1.92626 23.5791 3.05104 23.5791 4.44295C23.5791 5.58179 22.8058 6.55191 21.7513 6.86123L22.3559 11.9227C23.0589 12.0352 23.6072 12.6538 23.6072 13.385C23.6072 14.2145 22.9323 14.8893 22.1169 14.8893C20.4859 14.8893 20.0501 12.6398 21.5404 12.0212L20.9499 6.95965ZM12.1204 9.43416C10.4051 9.43416 9.01316 10.8401 9.01316 12.5554C9.01316 14.2707 10.4051 15.6626 12.1204 15.6626C13.8357 15.6626 15.2276 14.2707 15.2276 12.5554C15.2276 10.8401 13.8357 9.43416 12.1204 9.43416ZM11.0518 1.16703C10.4191 1.16703 9.91298 1.67318 9.91298 2.30587C9.91298 2.9245 10.4191 3.44471 11.0518 3.44471C11.6845 3.44471 12.1907 2.9245 12.1907 2.30587C12.1907 1.67318 11.6845 1.16703 11.0518 1.16703ZM22.0466 12.7241C21.1748 12.8366 21.2873 14.0739 22.1169 14.0739C23.0448 14.0739 22.9745 12.6257 22.0466 12.7241ZM2.40508 16.211C3.89541 16.0985 3.79699 13.9192 2.34884 13.9192C1.71615 13.9192 1.21 14.4394 1.21 15.0581C1.21 15.7189 1.77239 16.2391 2.40508 16.211ZM19.0659 20.7804C18.9675 21.4974 19.5017 22.0879 20.1907 22.0879C20.8234 22.0879 21.3295 21.5818 21.3295 20.9491C21.3295 19.5431 19.2627 19.4166 19.0659 20.7804ZM12.5703 19.1635C11.6845 19.1635 11.6845 20.5133 12.5703 20.5133C13.4701 20.5133 13.456 19.1635 12.5703 19.1635ZM5.44198 6.55191C4.51404 6.55191 3.74075 7.31114 3.74075 8.25314C3.74075 9.19515 4.51404 9.95438 5.44198 9.95438C6.38399 9.95438 7.15727 9.19515 7.15727 8.25314C7.15727 7.31114 6.38399 6.55191 5.44198 6.55191ZM2.75657 20.5554C2.12388 20.5554 1.60367 21.0616 1.60367 21.6943C1.60367 22.327 2.12388 22.8331 2.75657 22.8331C3.3752 22.8331 3.89541 22.327 3.89541 21.6943C3.89541 21.0616 3.3752 20.5554 2.75657 20.5554ZM21.0624 2.74172C20.1204 2.74172 19.3611 3.50095 19.3611 4.44295C19.3611 5.38495 20.1204 6.14418 21.0624 6.14418C22.0044 6.14418 22.7636 5.38495 22.7636 4.44295C22.7636 3.50095 22.0044 2.74172 21.0624 2.74172Z" fill="#270949" />
                    </g>
                    <defs>
                        <clipPath id="clip0_459_24">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            image: pharmaceuticalsImage
        },

        {
            title: "Banking",
            description: "We revolutionize the banking industry with AI-driven solutions that simplify operational processes, enhance customer engagement, and empower financial institutions with actionable insights for smarter, more efficient banking experiences.",
            kpiTitle: "Client Onboarding Efficiency",
            kpiValue: "+60%",
            kpiDescription: "Our AI-driven licensing chatbot cut the end-to-end onboarding process for a bank by 60%, accelerating approvals and compliance checks in real time.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_462_5)">
                        <path d="M0.454644 12.0666L2.36737 12.8212C2.62012 12.9209 2.8957 12.8682 3.09281 12.703L4.60753 13.6583L4.86731 13.8409C4.53778 14.3625 4.6222 15.0751 5.12324 15.5C5.39854 15.7334 5.74837 15.833 6.09079 15.7957C6.1109 16.1557 6.27458 16.4762 6.54098 16.702C6.80277 16.924 7.14454 17.0377 7.50847 16.998C7.52872 17.3578 7.69232 17.6783 7.95871 17.9041C8.22294 18.1282 8.56536 18.2395 8.92681 18.2001C8.9457 18.539 9.09772 18.8699 9.37644 19.1062C9.91484 19.5629 10.7248 19.4966 11.1813 18.9583L11.4852 18.6015L11.9974 18.9795C12.883 19.6332 14.1347 19.0977 14.2501 18.0112C15.1631 18.3429 16.1326 17.703 16.1467 16.7204C17.0073 16.8822 17.771 16.2571 17.8189 15.428C18.9353 15.7261 19.945 14.5981 19.4521 13.495L20.8208 12.6159C21.0168 12.848 21.3425 12.9357 21.6329 12.8212L23.5456 12.0666C23.9138 11.9214 24.0952 11.5037 23.9499 11.1354L23.0757 8.91948C23.0045 8.73883 22.8002 8.65023 22.6197 8.72148C22.439 8.79273 22.3504 8.99692 22.4216 9.17753L23.2958 11.3934C23.2988 11.401 23.2951 11.4096 23.2876 11.4126L21.3748 12.1671C21.3672 12.1701 21.3587 12.1664 21.3557 12.1589C21.2888 11.9891 19.1418 6.54691 18.952 6.06569C18.9513 6.064 18.9497 6.06007 18.9522 6.05449C18.9546 6.04891 18.9586 6.04736 18.9602 6.04666L20.873 5.29207C20.8747 5.29137 20.8786 5.28982 20.8843 5.29226C20.8898 5.29469 20.8914 5.29863 20.8921 5.30032L21.8188 7.64941C21.8901 7.83006 22.0943 7.91866 22.2749 7.84741C22.4555 7.77616 22.5442 7.57197 22.4729 7.39136L21.5462 5.04232C21.401 4.67416 20.9832 4.49276 20.6151 4.63802L18.7022 5.39262C18.3605 5.52743 18.1801 5.89418 18.2717 6.24185L17.2464 6.62032C16.9273 6.73811 16.5809 6.77228 16.2447 6.71899L15.2082 6.55469C15.0165 6.52436 14.8363 6.65519 14.806 6.84686C14.7756 7.03863 14.9064 7.21877 15.0981 7.24914L16.1346 7.41344C16.5895 7.48549 17.058 7.43931 17.4899 7.27989L18.5245 6.89796C18.6369 7.18267 20.4092 11.6751 20.5254 11.9699L19.0168 12.9388L18.9912 12.9199C18.9911 12.9198 18.991 12.9197 18.9909 12.9197C18.8293 12.8004 16.2061 10.8646 16.083 10.7737C16.0076 10.718 15.914 10.693 15.8063 10.7113C14.3499 10.959 13.045 10.4411 12.0851 9.43876C11.7864 9.1269 11.2991 9.11017 10.9755 9.4007C10.0442 10.2371 8.74283 11.0527 7.83228 10.1873C7.74182 10.1014 7.74116 9.94267 7.87855 9.85398C9.03842 9.10787 10.24 8.06027 11.2069 7.08208C11.4476 6.83857 11.7937 6.72536 12.1334 6.77922L13.4679 6.99077C13.66 7.02119 13.8397 6.89032 13.8701 6.6986C13.9005 6.50683 13.7697 6.32669 13.5779 6.29632L12.2434 6.08477C11.6808 5.99561 11.1064 6.18368 10.7069 6.58783C10.595 6.70094 10.4628 6.83228 10.3136 6.97633C9.86342 6.81672 9.3942 6.72138 8.91692 6.69457C7.51986 6.6161 7.39869 6.60128 7.08144 6.62168C6.83244 6.63757 6.57913 6.59524 6.34874 6.49886L5.72915 6.2396C5.81859 5.89394 5.63845 5.52677 5.29804 5.39252L3.38531 4.63802C3.01701 4.49271 2.59936 4.67412 2.45414 5.04232L0.0503476 11.1354C-0.095199 11.5044 0.0855038 11.921 0.454644 12.0666ZM6.39238 14.8966C6.18637 15.1396 5.82107 15.1697 5.57798 14.9637C5.33329 14.7562 5.30554 14.3915 5.51043 14.1499L6.38001 13.1292C6.58115 12.8919 6.94743 12.8528 7.19441 13.0621C7.43797 13.2686 7.46807 13.6329 7.26144 13.8766C7.26135 13.8766 7.2613 13.8767 7.26121 13.8768L6.39238 14.8966ZM7.81007 16.0988C7.60358 16.3423 7.23941 16.3724 6.99571 16.1658C6.75102 15.9583 6.72327 15.5936 6.92816 15.352L7.79774 14.3313C8.01369 14.0765 8.41396 14.0543 8.65494 14.3045C8.65653 14.3061 8.65789 14.3079 8.65949 14.3096C8.85795 14.5207 8.87089 14.8526 8.67917 15.0787L7.81007 16.0988ZM9.2278 17.3008C9.02056 17.5453 8.65602 17.5735 8.41344 17.3678C8.16875 17.1604 8.14096 16.7957 8.34585 16.5541L9.21547 15.5334C9.42205 15.2898 9.7887 15.2617 10.0299 15.4664C10.2729 15.6725 10.3029 16.0378 10.0969 16.2808C10.0968 16.2809 10.0968 16.281 10.0967 16.281L9.2278 17.3008ZM11.5194 17.4767C11.5179 17.4785 11.5167 17.4804 11.5152 17.4822C11.3749 17.6468 10.9884 18.1004 10.6455 18.5029C10.4395 18.7459 10.0742 18.776 9.83117 18.5699C9.58813 18.3639 9.55808 17.9986 9.76358 17.7562L10.6332 16.7355C10.8404 16.4911 11.2053 16.4629 11.4476 16.6685C11.686 16.8705 11.7225 17.2311 11.5194 17.4767ZM5.47649 6.89622L6.07729 7.14761C6.40701 7.28557 6.76982 7.34636 7.1264 7.32344C7.39527 7.30614 7.48504 7.31842 8.87736 7.39666C9.16325 7.41274 9.44591 7.45699 9.72195 7.5288C9.03406 8.14999 8.26157 8.77262 7.4878 9.2695C6.99172 9.58797 6.91822 10.2888 7.34793 10.6972C7.93522 11.2553 9.24861 11.8968 11.4453 9.92397C11.4846 9.88862 11.5426 9.88909 11.5771 9.92523C12.6412 11.0359 14.1494 11.6563 15.7782 11.4274C15.9627 11.5571 15.6054 11.2952 18.5732 13.4856C18.8909 13.7199 18.9797 14.1809 18.7311 14.4991C18.4949 14.8013 18.0681 14.8598 17.7597 14.6321C17.3431 14.3246 17.6507 14.5587 16.1861 13.4302C16.0321 13.3116 15.8115 13.3403 15.6929 13.4941C15.5745 13.6478 15.6031 13.8686 15.7568 13.9871L16.972 14.9234C17.1813 15.1992 17.1564 15.5978 16.9085 15.845C16.6649 16.0882 16.2638 16.1111 15.9756 15.8985C15.6969 15.6929 15.9284 15.8691 14.6503 14.8851C14.4965 14.7666 14.2757 14.7953 14.1573 14.9492C14.0389 15.103 14.0675 15.3238 14.2214 15.4422L15.2988 16.2718C15.5023 16.535 15.4923 16.9135 15.2702 17.1654C15.0311 17.4365 14.6075 17.4742 14.3058 17.2515C13.8208 16.8936 14.0642 17.0784 13.1304 16.3556C12.9768 16.2368 12.756 16.2649 12.6372 16.4185C12.5183 16.572 12.5464 16.7928 12.7 16.9117L13.447 17.4898C13.6169 17.7602 13.5836 18.1144 13.3601 18.3481C13.1163 18.6032 12.7099 18.6315 12.4149 18.4138L11.9423 18.065L12.0508 17.9376C12.2673 17.6824 12.3791 17.3519 12.3505 17.0041C12.3214 16.6518 12.154 16.3457 11.9022 16.1322C11.6404 15.9101 11.2983 15.7964 10.9345 15.8358C10.9153 15.4962 10.7596 15.1634 10.4845 14.9301C10.2236 14.7089 9.89239 14.6026 9.551 14.6304C9.53961 14.6314 9.52822 14.6325 9.51692 14.6337C9.51627 14.6225 9.51589 14.6112 9.51495 14.5999C9.49259 14.3281 9.38666 14.0763 9.21252 13.8732C9.21144 13.872 9.21045 13.8707 9.20938 13.8694C8.93235 13.5489 8.51994 13.387 8.09961 13.4322C8.07983 13.0792 7.9198 12.7555 7.64905 12.5259C7.11022 12.0691 6.30037 12.1358 5.84413 12.6739L5.31431 13.2958L5.0046 13.0781C4.99982 13.0747 4.99495 13.0714 4.98998 13.0683L3.4297 12.0843C4.60931 9.09428 4.16746 10.2143 5.47649 6.89622ZM0.704393 11.3935L3.10814 5.30041C3.11044 5.2946 3.11597 5.29108 3.12183 5.29108C3.12361 5.29108 3.12544 5.29141 3.12722 5.29212L5.03995 6.04671C5.04749 6.04966 5.0512 6.05824 5.04824 6.06574C4.9326 6.35889 2.72011 11.9671 2.64445 12.1589C2.64136 12.1666 2.63311 12.1702 2.62542 12.1672L0.71269 11.4126C0.705096 11.4096 0.701346 11.4011 0.704393 11.3935Z" fill="#270949" />
                    </g>
                    <defs>
                        <clipPath id="clip0_462_5">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            image: bankingImage
        },

        {
            title: "Technology",
            description: "We empower technology enterprises with AI solutions that optimize semiconductor programming, accelerate embedded system development, and enhance operational efficiency across electronics manufacturing workflows.",
            kpiTitle: "R&D Efficiency",
            kpiValue: "+2.5x",
            kpiDescription: "By providing engineering and product teams with real-time data through our AI chatbot, we accelerated development cycles by 2.5× across the enterprise.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15.9999V7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.5 4.21094L12 6.81094L16.5 4.21094" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.5 19.79V14.6L3 12" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21 12L16.5 14.6V19.79" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.26953 6.96094L11.9995 12.0109L20.7295 6.96094" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 22.08V12" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
            image: technologyImage
        }
    ];

    const current = industries[activeIndustryIndex];

    const toggleSolution = (solution) => {
        setOpenSolution(openSolution === solution ? null : solution);
    };

    return (

        <div className={styles.homePage}>

            <nav className={styles.navigationBar}>
                <div className={styles.logoAndCompanyTitle}>

                    <svg className={styles.companyLogo} xmlns="http://www.w3.org/2000/svg" width="174" height="50" viewBox="0 0 174 50" fill="none">
                        <path d="M16.7849 45.5387H6.92573C5.5666 45.5387 4.46094 44.4331 4.46094 43.0739V33.2148C4.46094 31.8557 5.5666 30.75 6.92573 30.75H16.7849C18.144 30.75 19.2497 31.8557 19.2497 33.2148V43.0739C19.2497 44.4331 18.144 45.5387 16.7849 45.5387ZM6.92573 32.3932C6.47272 32.3932 6.10413 32.7618 6.10413 33.2148V43.0739C6.10413 43.527 6.47272 43.8955 6.92573 43.8955H16.7849C17.2379 43.8955 17.6065 43.527 17.6065 43.0739V33.2148C17.6065 32.7618 17.2379 32.3932 16.7849 32.3932H6.92573Z" fill="#3B5CC6" />
                        <path d="M43.0739 19.2497H33.2148C31.8557 19.2497 30.75 18.144 30.75 16.7849V6.92573C30.75 5.5666 31.8557 4.46094 33.2148 4.46094H43.0739C44.4331 4.46094 45.5387 5.5666 45.5387 6.92573V16.7849C45.5387 18.144 44.4331 19.2497 43.0739 19.2497ZM33.2148 6.10413C32.7618 6.10413 32.3932 6.47272 32.3932 6.92573V16.7849C32.3932 17.2379 32.7618 17.6065 33.2148 17.6065H43.0739C43.527 17.6065 43.8955 17.2379 43.8955 16.7849V6.92573C43.8955 6.47272 43.527 6.10413 43.0739 6.10413H33.2148Z" fill="#3B5CC6" />
                        <path d="M21.7148 38.9694V37.3262C21.717 37.3262 22.3938 37.3147 23.0323 36.9809C23.8044 36.5772 24.1796 35.884 24.1796 34.8614V15.1431C24.1796 13.4912 24.9245 12.2089 26.277 11.5327C27.2441 11.0491 28.1837 11.0352 28.2876 11.0352L28.2921 12.6783C28.2854 12.6783 27.6087 12.6899 26.9701 13.0237C26.1981 13.4273 25.8228 14.1206 25.8228 15.1431V34.8614C25.8228 36.5134 25.0779 37.7957 23.7255 38.4718C22.7584 38.9555 21.8188 38.9694 21.7148 38.9694Z" fill="#3B5CC6" />
                        <path d="M76.0758 38.8839L73.1547 31.3725H61.2426L58.3974 38.8839H54.4141L65.1122 11.9869H69.399L80.0971 38.8839H76.0758ZM67.1607 15.8565L62.5704 27.9203H71.8269L67.1607 15.8565ZM88.2914 14.8701V20.6365H92.2368V23.8611H88.2914V33.3452C88.2914 35.0144 88.9742 35.849 90.8331 35.849C91.2883 35.849 91.9333 35.7731 92.2368 35.6973V38.7322C91.9333 38.846 91.0228 39.0736 89.8088 39.0736C86.698 39.0736 84.7253 37.1768 84.7253 33.8763V23.8611H81.2352V20.6365H82.2215C84.1942 20.6365 85.0288 19.4225 85.0288 17.8292V14.8701H88.2914ZM100.507 38.8839H96.9788V20.6365H100.507V38.8839ZM96.1822 13.732C96.1822 12.2904 97.3202 11.1523 98.7239 11.1523C100.165 11.1523 101.304 12.2904 101.304 13.732C101.304 15.1357 100.165 16.2738 98.7239 16.2738C97.3202 16.2738 96.1822 15.1357 96.1822 13.732ZM116.706 20.4468V24.2404C116.175 24.1646 115.644 24.1266 115.15 24.1266C112.153 24.1266 110.143 25.72 110.143 29.7412V38.8839H106.577V20.6365H110.067V23.8231C111.395 21.0158 113.671 20.333 115.53 20.333C116.023 20.333 116.516 20.4088 116.706 20.4468ZM119.361 33.9901C119.361 30.7276 121.751 28.9066 124.9 28.4514L129.832 27.7306C130.932 27.5788 131.235 27.0098 131.235 26.3649C131.235 24.5819 130.059 23.1023 127.29 23.1023C124.786 23.1023 123.383 24.6577 123.155 26.7822L119.741 25.9855C120.12 22.4954 123.269 20.0674 127.214 20.0674C132.677 20.0674 134.802 23.1782 134.802 26.7442V35.8869C134.802 37.4803 134.953 38.4287 135.029 38.8839H131.539C131.463 38.4287 131.349 37.7458 131.349 36.4181C130.553 37.7079 128.732 39.453 125.469 39.453C121.751 39.453 119.361 36.8733 119.361 33.9901ZM125.962 36.456C128.883 36.456 131.235 35.0523 131.235 31.069V30.2344L125.659 31.069C124.141 31.2966 123.003 32.1692 123.003 33.8004C123.003 35.1661 124.141 36.456 125.962 36.456ZM145.12 14.8701V20.6365H149.066V23.8611H145.12V33.3452C145.12 35.0144 145.803 35.849 147.662 35.849C148.117 35.849 148.762 35.7731 149.066 35.6973V38.7322C148.762 38.846 147.852 39.0736 146.638 39.0736C143.527 39.0736 141.554 37.1768 141.554 33.8763V23.8611H138.064V20.6365H139.05C141.023 20.6365 141.858 19.4225 141.858 17.8292V14.8701H145.12ZM157.374 28.1479V38.8839H153.808V11.4179H157.374V22.7609C158.702 20.8262 160.826 20.1054 162.912 20.1054C167.275 20.1054 169.438 23.2541 169.438 27.3133V38.8839H165.872V27.9203C165.872 25.3785 164.809 23.33 161.623 23.33C158.891 23.33 157.45 25.4544 157.374 28.1479Z" fill="#270949" />
                    </svg>

                </div>

                {/* 
                {isMobile ? (
                    <div className={styles.navigationMenu}>

                        <svg className={styles.navigationMenuIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21 10H3" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21 6H3" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21 14H3" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21 18H3" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </div>
                ) : (
                    <ul className={styles.navigationItems}>
                        <li className={styles.solutionsNavigationItem}>Solutions</li>
                        <li className={styles.researchNavigationItem}>Research</li>
                        <li className={styles.companyNavigationItem}>Company</li>
                        <li className={styles.industriesNavigationItem}>Industries</li>
                    </ul>
                )}
                */}
            </nav>

            <div className={styles.heroHeaderSection}>

                <HeroAnimation />

                <h1 className={styles.heroHeaderTitle} > Empowering Enterprises with AI Solutions </h1>

                <p className={styles.heroHeaderTagline} > Deliver intelligent, autonomous, and adaptive solutions for Enterprise Workflow Automation. </p>

                <div className={styles.heroHeaderButtonWrapper}>

                    {isMobile ? (
                        <>
                            {/* ✅ MOBILE BUTTON */}
                            <svg
                                className={styles.heroHeaderButtonBackground}
                                xmlns="http://www.w3.org/2000/svg"
                                width="249"
                                height="49"
                                viewBox="0 0 249 49"
                                fill="none"
                            >
                                <path
                                    d="M0 10C0 4.47715 4.47715 0 10 0H238.183C246.095 0 250.873 8.75246 246.595 15.4076L227.952 44.4076C226.112 47.2698 222.943 49 219.54 49H10C4.47715 49 0 44.5228 0 39V10Z"
                                    fill="#3B5CC6"
                                />
                            </svg>

                            <button className={styles.heroHeaderScheduleMeetingButton} onClick={scrollToContact}>
                                <span className={styles.SMBText}>Schedule a Meeting</span>
                                <svg
                                    className={styles.SMBArrow}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </>
                    ) : (
                        <>
                            {/* ✅ DESKTOP BUTTON */}
                            <svg
                                className={styles.heroHeaderButtonBackground}
                                xmlns="http://www.w3.org/2000/svg"
                                width="295"
                                height="56"
                                viewBox="0 0 295 56"
                                fill="none"
                            >
                                <path
                                    d="M0 10C0 4.47715 4.4775 0 10 0H284.755C292.651 0 297.432 8.72333 293.184 15.38L270.207 51.38C268.371 54.258 265.192 56 261.778 56H10C4.47716 56 0 51.5228 0 46V10Z"
                                    fill="#3B5CC6"
                                />
                            </svg>

                            <button className={styles.heroHeaderScheduleMeetingButton} onClick={scrollToContact}>
                                <span className={styles.SMBText}>Schedule a Meeting</span>
                                <svg
                                    className={styles.SMBArrow}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </>
                    )}
                </div>


            </div>

            <div className={styles.aiPoweredSolutionSection}>

                <svg className={styles.solutionSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="430" height="2" viewBox="0 0 430 2" fill="none">
                    <path d="M1 1H429" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                </svg>

                <p className={styles.solutionSectionTitle}>

                    DISCOVER OUR AI-POWERED SOLUTIONS
                </p>

                <div className={styles.solutionList}>

                    <div className={styles.enterpriseAiStrategySolutionSection}>
                        {isMobile ? (
                            <>
                                <div className={styles.solutionSectionTitleAndArrowSection}>

                                    <h3 className={styles.enterpriseAiStrategyTitle}>
                                        Enterprise AI Strategy
                                    </h3>
                                    <button
                                        className={styles.solutionDropDownArrow}
                                        onClick={() => toggleSolution("enterprise")}
                                    >

                                        <svg className={`${styles.solutionDropDownArrowIcon} ${openSolution === "enterprise" ? styles.rotateArrow : ''
                                            }`} xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
                                            <rect x="0.7" y="1.2" width="33.6" height="33.6" rx="16.8" stroke="#D6DFE7" stroke-width="1.4" />
                                            <path d="M11.6719 15.1992L17.5052 21.0326L23.3385 15.1992" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                <p className={styles.enterpriseAiStrategyDescription}>
                                    Transforming enterprises by seamlessly integrating intelligent AI solutions to accelerate innovation and strategic growth.
                                </p>
                            </>
                        ) : (
                            <>
                                <h3 className={styles.enterpriseAiStrategyTitle}>
                                    Enterprise AI Strategy
                                </h3>
                                <p className={styles.enterpriseAiStrategyDescription}>
                                    Transforming enterprises by seamlessly integrating intelligent AI solutions to accelerate innovation and strategic growth.
                                </p>
                                <button
                                    className={styles.solutionDropDownArrow}
                                    onClick={() => toggleSolution("enterprise")}
                                >
                                    <svg className={`${styles.solutionDropDownArrowIcon} ${openSolution === "enterprise" ? styles.rotateArrow : ''}`} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#D6DFE7" stroke-width="2" />
                                        <path d="M16.6758 21L25.0091 29.3333L33.3424 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </>
                        )}
                    </div>


                    {openSolution === "enterprise" && (

                        <div className={styles.expandedEnterpriseAiSolution}>

                            <div className={styles.streamlineEnterpriseOperationsSection}>

                                <svg className={styles.streamlineOperationsIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_522_218)">
                                        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_522_218">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <p className={styles.streamlineOperationsDescription}>

                                    Streamline Enterprise Operations

                                </p>

                            </div>

                            <div className={styles.intelligentWorkflowAutomationSection}>

                                <svg className={styles.intelligentWorkflowAutomationIcon} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M18.332 3C17.5364 3 16.7733 3.31607 16.2107 3.87868C15.6481 4.44129 15.332 5.20435 15.332 6V18C15.332 18.7956 15.6481 19.5587 16.2107 20.1213C16.7733 20.6839 17.5364 21 18.332 21C19.1277 21 19.8907 20.6839 20.4534 20.1213C21.016 19.5587 21.332 18.7956 21.332 18C21.332 17.2044 21.016 16.4413 20.4534 15.8787C19.8907 15.3161 19.1277 15 18.332 15H6.33203C5.53638 15 4.77332 15.3161 4.21071 15.8787C3.6481 16.4413 3.33203 17.2044 3.33203 18C3.33203 18.7956 3.6481 19.5587 4.21071 20.1213C4.77332 20.6839 5.53638 21 6.33203 21C7.12768 21 7.89074 20.6839 8.45335 20.1213C9.01596 19.5587 9.33203 18.7956 9.33203 18V6C9.33203 5.20435 9.01596 4.44129 8.45335 3.87868C7.89074 3.31607 7.12768 3 6.33203 3C5.53638 3 4.77332 3.31607 4.21071 3.87868C3.6481 4.44129 3.33203 5.20435 3.33203 6C3.33203 6.79565 3.6481 7.55871 4.21071 8.12132C4.77332 8.68393 5.53638 9 6.33203 9H18.332C19.1277 9 19.8907 8.68393 20.4534 8.12132C21.016 7.55871 21.332 6.79565 21.332 6C21.332 5.20435 21.016 4.44129 20.4534 3.87868C19.8907 3.31607 19.1277 3 18.332 3Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <p className={styles.intelligentWorkflowAutomationDescription}>

                                    Intelligent Workflow Automation

                                </p>

                            </div>

                            <div className={styles.aiEnhancedCustomerExperiencesSection}>

                                <svg className={styles.aiEnhancedCustomerExperiencesIcon} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M20.668 21V19C20.668 17.9391 20.2465 16.9217 19.4964 16.1716C18.7462 15.4214 17.7288 15 16.668 15H8.66797C7.6071 15 6.58969 15.4214 5.83954 16.1716C5.0894 16.9217 4.66797 17.9391 4.66797 19V21" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.668 11C14.8771 11 16.668 9.20914 16.668 7C16.668 4.79086 14.8771 3 12.668 3C10.4588 3 8.66797 4.79086 8.66797 7C8.66797 9.20914 10.4588 11 12.668 11Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <p className={styles.aiEnhancedCustomerExperiencesDescription}>

                                    AI-Enhanced Customer Experiences

                                </p>

                            </div>

                            <div className={styles.acceleratedDataDrivenDecisionSection}>

                                <svg className={styles.acceleratedDataDrivenDecisionIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14 2V8H20" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 13H8" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 17H8" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 9H9H8" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <p className={styles.acceleratedDataDrivenDecisionDescription}>

                                    Accelerate Data-Driven Decision Making

                                </p>

                            </div>

                        </div>
                    )}

                    <div className={styles.customRagSolutionSection}>
                        {isMobile ? (
                            <>
                                <div className={styles.solutionSectionTitleAndArrowSection}>
                                    <h3 className={styles.customRagSolutionsTitle}>
                                        Custom RAG Solutions
                                    </h3>
                                    <button
                                        className={styles.solutionDropDownArrow}
                                        onClick={() => toggleSolution("customRag")}
                                    >
                                        <svg
                                            className={`${styles.solutionDropDownArrowIcon} ${openSolution === "customRag" ? styles.rotateArrow : ''}`}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="35"
                                            height="36"
                                            viewBox="0 0 35 36"
                                            fill="none"
                                        >
                                            <rect x="0.7" y="1.2" width="33.6" height="33.6" rx="16.8" stroke="#D6DFE7" strokeWidth="1.4" />
                                            <path d="M11.6719 15.1992L17.5052 21.0326L23.3385 15.1992" stroke="black" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                <p className={styles.customRagSolutionsDescription}>
                                    Transforming data retrieval by instantly connecting businesses with relevant, real-time information for smarter decisions.
                                </p>
                            </>
                        ) : (
                            <>
                                <h3 className={styles.customRagSolutionsTitle}>
                                    Custom RAG Solutions
                                </h3>
                                <p className={styles.customRagSolutionsDescription}>
                                    Transforming data retrieval by instantly connecting businesses with relevant, real-time information for smarter decisions.
                                </p>
                                <button
                                    className={styles.solutionDropDownArrow}
                                    onClick={() => toggleSolution("customRag")}
                                >
                                    <svg className={`${styles.solutionDropDownArrowIcon} ${openSolution === "customRag" ? styles.rotateArrow : ''}`} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#D6DFE7" stroke-width="2" />
                                        <path d="M16.6758 21L25.0091 29.3333L33.3424 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </>
                        )}
                    </div>


                    {openSolution === "customRag" && (

                        <div className={styles.expandedCustomRagSolution}>

                            <div className={styles.ragLeftSection}>

                                <div className={styles.userPromptMessage}>

                                    <div className={styles.userMessage}>

                                        <div className={styles.messageTimeAndName}>

                                            <p className={styles.messageTime}>

                                                04:24 PM

                                            </p>

                                            <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                                                <circle cx="3" cy="2.5" r="2.5" fill="white" />
                                            </svg>

                                            <p className={styles.senderName}>

                                                Oliver James

                                            </p>

                                        </div>

                                        <p className={styles.messageContent}>

                                            Which JTAG or debug interfaces are currently supported for our production chipsets?

                                        </p>


                                    </div>

                                    <img className={styles.userPicture} src={userPicture} alt="User" />

                                </div>

                                <div className={styles.chatBotPromptBlock}>

                                    <svg className={styles.promptCompanyLogo} xmlns="http://www.w3.org/2000/svg" width="124" height="110" viewBox="0 0 124 110" fill="none">
                                        <path d="M61.7997 78.4698L86.511 64.2031V92.7365L61.8004 107.003L37.0898 92.7365V64.2031L61.7997 78.4698Z" fill="#4654A3" />
                                        <path d="M86.5199 35.6665L61.8089 21.3992L86.5195 7.13257L111.23 21.3992L111.23 49.9326L86.5195 64.1992L86.5199 35.6665Z" fill="#4654A3" />
                                        <path d="M37.0593 35.6684L37.0589 64.2023L12.3484 49.9357L12.3484 21.4023L37.0589 7.13568L61.7695 21.4023L37.0593 35.6684Z" fill="#4654A3" />
                                    </svg>

                                    <div className={styles.chatBotPrompt}>

                                        <div className={styles.chatBotPromptMessage}>

                                            <div className={styles.aiTagAndMessageTime}>

                                                <p className={styles.aiTag}>

                                                    AI Assistant

                                                </p>

                                                <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                                                    <circle cx="3.07812" cy="2.5" r="2.5" fill="white" />
                                                </svg>

                                                <p className={styles.messageTime}>

                                                    04:25 PM

                                                </p>

                                            </div>

                                            <p className={styles.aiMessageContentOneFirstText}>

                                                Based on internal documentation and validated hardware interface data:

                                            </p>

                                            <ul className={styles.aiMessageContentOne}>
                                                <li>
                                                    <span className={styles.aiHighlightedText}>Supported Interfaces:</span> The current production chipsets support both 3-wire and 5-wire JTAG configurations, commonly used for embedded debug, flashing, and validation workflows.
                                                </li>
                                                <li>
                                                    <span className={styles.aiHighlightedText}>Use Cases:</span> These interfaces enable post-silicon debug, firmware flashing, and boundary scan diagnostics. Compatibility extends across all current production boards.
                                                </li>
                                                <li>
                                                    <span className={styles.aiHighlightedText}>Signal Map Coverage:</span> Pin configurations include TCK, TMS, TDI, TDO, and optional TRST, with standard voltage tolerance of 1.2V-3.3V.
                                                </li>
                                            </ul>


                                        </div>

                                        <div className={styles.chatBotPromptCitations}>

                                            <p className={styles.citationsTitle}>

                                                Citations

                                            </p>

                                            <div className={styles.citationAndDownload}>

                                                <div className={styles.citationContent}>

                                                    <svg className={styles.fileIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                                        <path d="M19.2435 2.66406H8.57682C7.86958 2.66406 7.1913 2.94501 6.6912 3.44511C6.19111 3.94521 5.91016 4.62349 5.91016 5.33073V26.6641C5.91016 27.3713 6.19111 28.0496 6.6912 28.5497C7.1913 29.0498 7.86958 29.3307 8.57682 29.3307H24.5768C25.2841 29.3307 25.9623 29.0498 26.4624 28.5497C26.9625 28.0496 27.2435 27.3713 27.2435 26.6641V10.6641L19.2435 2.66406Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M19.2461 2.66406V10.6641H27.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21.9128 17.332H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21.9128 22.6641H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M13.9128 12H12.5794H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                    <div className={styles.fileNameAndSize}>

                                                        <p className={styles.fileName}>

                                                            Intel JTAG Architecture Overview

                                                        </p>

                                                        <p className={styles.fileSize}>

                                                            9.6 MB

                                                        </p>

                                                    </div>

                                                </div>

                                                <svg className={styles.downloadIcon} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                    <path d="M21.5781 15V19C21.5781 19.5304 21.3674 20.0391 20.9923 20.4142C20.6173 20.7893 20.1086 21 19.5781 21H5.57812C5.04769 21 4.53898 20.7893 4.16391 20.4142C3.78884 20.0391 3.57813 19.5304 3.57812 19V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7.57812 10L12.5781 15L17.5781 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12.5781 15V3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </div>

                                            <div className={styles.citationAndDownload}>

                                                <div className={styles.citationContent}>

                                                    <svg className={styles.fileIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                                        <path d="M19.2435 2.66406H8.57682C7.86958 2.66406 7.1913 2.94501 6.6912 3.44511C6.19111 3.94521 5.91016 4.62349 5.91016 5.33073V26.6641C5.91016 27.3713 6.19111 28.0496 6.6912 28.5497C7.1913 29.0498 7.86958 29.3307 8.57682 29.3307H24.5768C25.2841 29.3307 25.9623 29.0498 26.4624 28.5497C26.9625 28.0496 27.2435 27.3713 27.2435 26.6641V10.6641L19.2435 2.66406Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M19.2461 2.66406V10.6641H27.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21.9128 17.332H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21.9128 22.6641H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M13.9128 12H12.5794H11.2461" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                    <div className={styles.fileNameAndSize}>

                                                        <p className={styles.fileName}>

                                                            Intel SoC Debug Interface Manual

                                                        </p>

                                                        <p className={styles.fileSize}>

                                                            12 MB

                                                        </p>

                                                    </div>

                                                </div>

                                                <svg className={styles.downloadIcon} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                    <path d="M21.5781 15V19C21.5781 19.5304 21.3674 20.0391 20.9923 20.4142C20.6173 20.7893 20.1086 21 19.5781 21H5.57812C5.04769 21 4.53898 20.7893 4.16391 20.4142C3.78884 20.0391 3.57813 19.5304 3.57812 19V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7.57812 10L12.5781 15L17.5781 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12.5781 15V3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </div>

                                        </div>

                                        <div className={styles.chatBotPromptMessage}>

                                            <div className={styles.aiTagAndMessageTime}>

                                                <p className={styles.aiTag}>

                                                    AI Assistant

                                                </p>

                                                <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5" fill="none">
                                                    <circle cx="3.07812" cy="2.5" r="2.5" fill="white" />
                                                </svg>

                                                <p className={styles.messageTime}>

                                                    04:25 PM

                                                </p>

                                            </div>

                                            <p className={styles.aiMessageContentTwoFirst}>

                                                Would you like help setting up programming workflows or reviewing JTAG timing configurations?

                                            </p>

                                            <p className={styles.aiMessageContentTwoSecond}>

                                                In case it's helpful, here are some recent internal validation metrics related to JTAG stability and signal mapping accuracy across supported devices.

                                            </p>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div className={styles.ragRightSection}>

                                <div className={styles.keyMetricsSection}>

                                    <p className={styles.keyMetricsTitle}>

                                        Key Metrics from Internal JTAG Validation Reports

                                    </p>

                                    <p className={styles.keyMetricInformation}>

                                        These figures are based on internal debug runs conducted across supported chipset families using both 3-wire and 5-wire JTAG configurations.

                                    </p>

                                    <div className={styles.metricSection}>

                                        <div className={styles.metricTitleAndValue}>

                                            <p className={styles.metricTitle}>

                                                Interface Auto-Detection Success Rate

                                            </p>

                                            <p className={styles.metricValue}>

                                                98.5%

                                            </p>


                                        </div>

                                        <div className={styles.interfaceAutoDetectionProgressBarContainer}>

                                            <div className={styles.interfaceAutoDetectionProgressBar} style={{ width: '98.5%' }}> </div>

                                        </div>

                                    </div>

                                    <div className={styles.metricSection}>

                                        <div className={styles.metricTitleAndValue}>

                                            <p className={styles.metricTitle}>

                                                Signal Map Accuracy (across voltage ranges)

                                            </p>

                                            <p className={styles.metricValue}>

                                                97.6%

                                            </p>


                                        </div>

                                        <div className={styles.signalMapAccuracyProgressBarContainer}>

                                            <div className={styles.signalMapAccuracyProgressBar} style={{ width: '97.6%' }}> </div>

                                        </div>

                                    </div>

                                </div>

                                <div className={styles.visualRepresentationSection}>

                                    <p className={styles.visualRepresentationSectionHeading}>

                                        Signal Integrity Across JTAG Modes

                                    </p>

                                    <div className={styles.visualRepresentation}>

                                        <div className={styles.yAxis}>

                                            <p className={styles.yAxisValue}>

                                                100%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                95%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                90%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                85%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                80%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                75%

                                            </p>

                                            <p className={styles.yAxisValue}>

                                                0

                                            </p>


                                        </div>

                                        <div className={styles.graph}>

                                            <div className={styles.graphElement}>

                                                <div className={styles.graphBarOne}>


                                                </div>

                                                <p className={styles.graphBarText}>

                                                    3-Wire JTAG

                                                </p>

                                            </div>

                                            <div className={styles.graphElement}>

                                                <div className={styles.graphBarTwo}>


                                                </div>

                                                <p className={styles.graphBarText}>

                                                    5-Wire JTAG

                                                </p>


                                            </div>

                                            <div className={styles.graphElement}>

                                                <div className={styles.graphBarThree}>


                                                </div>

                                                <p className={styles.graphBarText}>

                                                    Boundary Scan

                                                </p>


                                            </div>

                                            <div className={styles.graphElement}>

                                                <div className={styles.graphBarFour}>


                                                </div>

                                                <p className={styles.graphBarText}>

                                                    Multi-Core-Debug

                                                </p>


                                            </div>

                                            <div className={styles.graphElement}>

                                                <div className={styles.graphBarFive}>


                                                </div>

                                                <p className={styles.graphBarText}>

                                                    Hybrid Mode

                                                </p>


                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div className={styles.legendAndAnalysedInformationSection}>

                                    <div className={styles.legend}>

                                        <p className={styles.legendAxis}>

                                            <span className={styles.legendHighlightedText}> X-Axis - </span> Interface Configuration

                                        </p>

                                        <p className={styles.legendAxis}>

                                            <span className={styles.legendHighlightedText}> Y-Axis - </span> Stability Score (%)

                                        </p>


                                    </div>

                                    <div className={styles.analysedInformation}>

                                        <svg className={styles.informationIcon} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                            <path d="M12.75 22C18.2728 22 22.75 17.5228 22.75 12C22.75 6.47715 18.2728 2 12.75 2C7.22715 2 2.75 6.47715 2.75 12C2.75 17.5228 7.22715 22 12.75 22Z" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12.75 16V12" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12.75 8H12.76" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        <p className={styles.analysedInformationText}>

                                            These measurements help optimize signal trace tuning and interface selection during firmware development and board validation.

                                        </p>


                                    </div>

                                </div>

                            </div>


                        </div>
                    )}

                    <div className={styles.multilingualAiSolutionSection}>
                        {isMobile ? (
                            <>
                                <div className={styles.solutionSectionTitleAndArrowSection}>
                                    <h3 className={styles.multilingualAiSolutionTitle}>
                                        Multilingual AI Solutions
                                    </h3>
                                    <button
                                        className={styles.solutionDropDownArrow}
                                        onClick={() => toggleSolution("multilingualAi")}
                                    >
                                        <svg
                                            className={`${styles.solutionDropDownArrowIcon} ${openSolution === "multilingualAi" ? styles.rotateArrow : ''}`}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="35"
                                            height="36"
                                            viewBox="0 0 35 36"
                                            fill="none"
                                        >
                                            <rect x="0.7" y="1.2" width="33.6" height="33.6" rx="16.8" stroke="#D6DFE7" strokeWidth="1.4" />
                                            <path d="M11.6719 15.1992L17.5052 21.0326L23.3385 15.1992" stroke="black" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                <p className={styles.multilingualAiSolutionDescription}>
                                    Enabling businesses to communicate effortlessly across languages, unlocking valuable insights through scalable AI-driven data processing.
                                </p>
                            </>
                        ) : (
                            <>
                                <h3 className={styles.multilingualAiSolutionTitle}>
                                    Multilingual AI Solutions
                                </h3>
                                <p className={styles.multilingualAiSolutionDescription}>
                                    Enabling businesses to communicate effortlessly across languages, unlocking valuable insights through scalable AI-driven data processing.
                                </p>
                                <button
                                    className={styles.solutionDropDownArrow}
                                    onClick={() => toggleSolution("multilingualAi")}
                                >
                                    <svg className={`${styles.solutionDropDownArrowIcon} ${openSolution === "multilingualAi" ? styles.rotateArrow : ''}`} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#D6DFE7" stroke-width="2" />
                                        <path d="M16.6758 21L25.0091 29.3333L33.3424 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </>
                        )}
                    </div>


                    {openSolution === "multilingualAi" && (

                        <div className={styles.expandedMultilingualAiSolutionSection}>

                            <div className={styles.leftMultilingualAiSection}>

                                <div className={styles.leftMultilingualAiSectionTitleFrame}>

                                    <p className={styles.leftMultilingualAiSectionTitle}>

                                        Multilingual Regional Travel Coordination - Incoming Messages

                                    </p>

                                    <p className={styles.leftMultilingualAiSectionCaption}>

                                        Travel agents across regions are sharing critical updates in Telugu — including booking trends, delays, and field coordination.

                                    </p>

                                </div>

                                <div className={styles.multilingualPromptTypeOne}>

                                    <div className={styles.PromptTypeOneTimeAndName}>

                                        <p className={styles.timeValue}>

                                            04:24 PM

                                        </p>

                                        <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                            <circle cx="3" cy="3" r="2.5" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.nameValue}>

                                            Sowmya R.

                                        </p>


                                    </div>

                                    <div className={styles.PromptTypeOneBlock}>

                                        <p className={styles.PromptTypeOneBlockText}>

                                            ఈ వారం గోవా ప్యాకేజీల బుకింగ్‌లు ఎలా ఉన్నాయి? ఏమైనా కొత్త డిమాండ్ ట్రెండ్స్ కనిపిస్తున్నాయా?

                                        </p>

                                    </div>

                                </div>

                                <div className={styles.multilingualPromptTypeTwo}>

                                    <div className={styles.PromptTypeTwoTimeAndName}>

                                        <p className={styles.nameValue}>

                                            Ravi

                                        </p>

                                        <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                            <circle cx="3" cy="3" r="2.5" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.timeValue}>

                                            04:26 PM

                                        </p>


                                    </div>

                                    <div className={styles.PromptTypeTwoBlock}>

                                        <p className={styles.PromptTypeTwoBlockText}>

                                            విజాగ్‌లో ఉన్న మా బస్సింగ్ భాగస్వామి ఆలస్యం చేస్తున్నాడని వినిపిస్తోంది. రీషెడ్యూలింగ్ అవసరమా?

                                        </p>

                                    </div>

                                </div>

                                <div className={styles.multilingualPromptTypeOne}>

                                    <div className={styles.PromptTypeOneTimeAndName}>

                                        <p className={styles.timeValue}>

                                            04:28 PM

                                        </p>

                                        <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                            <circle cx="3" cy="3" r="2.5" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.nameValue}>

                                            Keerthi B.

                                        </p>


                                    </div>

                                    <div className={styles.PromptTypeOneBlock}>

                                        <p className={styles.PromptTypeOneBlockText}>

                                            మహాబలిపురం గైడ్‌లు ఇంగ్లీష్‌ మాట్లాడలేరు. బృందానికి తక్షణ అనువాద సహాయం కావాలి.

                                        </p>

                                    </div>

                                </div>

                                <div className={styles.multilingualPromptTypeTwo}>

                                    <div className={styles.PromptTypeTwoTimeAndName}>

                                        <p className={styles.nameValue}>

                                            Anil M.

                                        </p>

                                        <svg className={styles.timeAndNameSeperator} xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                            <circle cx="3" cy="3" r="2.5" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.timeValue}>

                                            04:30 PM

                                        </p>


                                    </div>

                                    <div className={styles.PromptTypeTwoBlock}>

                                        <p className={styles.PromptTypeTwoBlockText}>

                                            కశ్మీర్ టూర్ కోసం బ్రోషర్‌ల తెలుగు అనువాదం పూర్తయిందా? డిజిటల్ పంపిణీకి సిద్ధంగా ఉందా?

                                        </p>

                                    </div>


                                </div>

                            </div>

                            <div className={styles.rightMultilingualAiSection}>

                                <div className={styles.realTimeTextSummarisationSection}>

                                    <p className={styles.realTimeTextSummarisationSectionTitle}>

                                        AI-Powered Live Summarisation – Regional Travel Updates in Telugu

                                    </p>

                                    <p className={styles.realTimeTextSummarisationSectionCaption}>

                                        Atirath's multilingual AI extracts key insights from Indic language messages to enable quick, language-agnostic decision-making across global travel operations.

                                    </p>

                                    <div className={styles.languageChangerBox}>

                                        <p className={styles.languageText}>

                                            English

                                        </p>

                                        <svg className={styles.dropDownArrow} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                            <path d="M6.5 9L12.5 15L18.5 9" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <ul className={styles.realTimeTextSummarisationList}>
                                        <li>Sowmya asked about Goa booking trends and demand updates.</li>
                                        <li>Ravi flagged delays with a transport partner in Vizag.</li>
                                        <li>Keerthi requested translation help for guides in Mahabalipuram.</li>
                                        <li>Anil asked if the Telugu version of the Kashmir tour brochure was ready.</li>
                                    </ul>


                                </div>

                                <div className={styles.realTimeAudioSummarisationSection}>

                                    <p className={styles.realTimeAudioSummarisationSectionTitle}>

                                        Real-Time Audio Summarisation of Multilingual Converation

                                    </p>

                                    <div className={styles.languageChangerBox}>

                                        <p className={styles.languageText}>

                                            English

                                        </p>

                                        <svg className={styles.dropDownArrow} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                            <path d="M6.5 9L12.5 15L18.5 9" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.realTimeAudioSummarisationContent}>

                                        <svg className={styles.audioPlayIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                            <path d="M16.5013 29.3346C23.8651 29.3346 29.8346 23.3651 29.8346 16.0013C29.8346 8.63751 23.8651 2.66797 16.5013 2.66797C9.13751 2.66797 3.16797 8.63751 3.16797 16.0013C3.16797 23.3651 9.13751 29.3346 16.5013 29.3346Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.832 10.668L21.832 16.0013L13.832 21.3346V10.668Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        <div className={styles.audioPlayerProgress}>

                                            <div className={styles.timeStamps}>

                                                <p className={styles.timeStamp}>

                                                    0:00

                                                </p>

                                                <p className={styles.timeStamp}>

                                                    -4:42

                                                </p>

                                            </div>

                                            <div className={styles.audioSummarisationProgressBarContainer}>

                                                <div className={styles.audioSummarisationProgressBar} style={{ width: '60%' }}> </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    )}

                    <div className={styles.analyticsAndInsightsSection}>
                        {isMobile ? (
                            <>
                                <div className={styles.solutionSectionTitleAndArrowSection}>
                                    <h3 className={styles.analyticsAndInsightsTitle}>
                                        Analytics and Insights
                                    </h3>
                                    <button
                                        className={styles.solutionDropDownArrow}
                                        onClick={() => toggleSolution("analyticsAndInsights")}
                                    >
                                        <svg
                                            className={`${styles.solutionDropDownArrowIcon} ${openSolution === "analyticsAndInsights" ? styles.rotateArrow : ''}`}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="35"
                                            height="36"
                                            viewBox="0 0 35 36"
                                            fill="none"
                                        >
                                            <rect x="0.7" y="1.2" width="33.6" height="33.6" rx="16.8" stroke="#D6DFE7" strokeWidth="1.4" />
                                            <path d="M11.6719 15.1992L17.5052 21.0326L23.3385 15.1992" stroke="black" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                <p className={styles.analyticsAndInsightsDescription}>
                                    Unlocking business growth with AI-driven analytics that convert complex data into actionable strategies and measurable outcomes.
                                </p>
                            </>
                        ) : (
                            <>
                                <h3 className={styles.analyticsAndInsightsTitle}>
                                    Analytics and Insights
                                </h3>
                                <p className={styles.analyticsAndInsightsDescription}>
                                    Unlocking business growth with AI-driven analytics that convert complex data into actionable strategies and measurable outcomes.
                                </p>
                                <button
                                    className={styles.solutionDropDownArrow}
                                    onClick={() => toggleSolution("analyticsAndInsights")}
                                >
                                    <svg className={`${styles.solutionDropDownArrowIcon} ${openSolution === "analyticsAndInsights" ? styles.rotateArrow : ''}`} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#D6DFE7" stroke-width="2" />
                                        <path d="M16.6758 21L25.0091 29.3333L33.3424 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </>
                        )}
                    </div>


                    {openSolution === "analyticsAndInsights" && (

                        <div className={styles.expandedAnalyticsAndInsightsSection}>

                            <div className={styles.rawDataSourcesSection}>

                                <p className={styles.rawDataSourcesSectionTitle}>

                                    Raw Data Sources

                                </p>

                                <div className={styles.rawDataSources}>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Customer Survey Feedback

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    12 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Product Review Aggregates

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    12 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Customer Support Tickets

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    12 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Social Media Mentions

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    10 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Website Chatbot Logs

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    8 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                    <div className={styles.rawDataSource}>

                                        <div className={styles.dataFileSection}>

                                            <svg className={styles.dataFileIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                                                <path d="M18.6654 3.16406H7.9987C7.29145 3.16406 6.61318 3.44501 6.11308 3.94511C5.61298 4.44521 5.33203 5.12349 5.33203 5.83073V27.1641C5.33203 27.8713 5.61298 28.5496 6.11308 29.0497C6.61318 29.5498 7.29145 29.8307 7.9987 29.8307H23.9987C24.7059 29.8307 25.3842 29.5498 25.8843 29.0497C26.3844 28.5496 26.6654 27.8713 26.6654 27.1641V11.1641L18.6654 3.16406Z" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.668 3.16406V11.1641H26.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 17.832H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M21.3346 23.1641H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M13.3346 12.5H12.0013H10.668" stroke="#270949" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div className={styles.dataSourceFileNameAndSize}>

                                                <p className={styles.dataSourceFileName}>

                                                    Sales/CRM Data

                                                </p>

                                                <p className={styles.dataSourceFileSize}>

                                                    15 MB

                                                </p>

                                            </div>

                                        </div>

                                        <svg className={styles.dataDownloadIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <path d="M21 15.8984V19.8984C21 20.4289 20.7893 20.9376 20.4142 21.3127C20.0391 21.6877 19.5304 21.8984 19 21.8984H5C4.46957 21.8984 3.96086 21.6877 3.58579 21.3127C3.21071 20.9376 3 20.4289 3 19.8984V15.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7 10.8984L12 15.8984L17 10.8984" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.8984V3.89844" stroke="#270949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>

                                </div>

                            </div>

                            <div className={styles.feedbackBreakdownSection}>

                                <div className={styles.feedbackBreakdownSectionTitleFrame}>

                                    <p className={styles.feedbackBreakdownSectionTitle}>

                                        AI-Powered Feedback Breakdown

                                    </p>

                                </div>

                                <div className={styles.pieChartSection}>

                                    <div className={styles.pie}></div>
                                    <div className={styles.innerCircle}></div>

                                    <span className={`${styles.percentageLabel} ${styles.label60}`}>60%</span>
                                    <span className={`${styles.percentageLabel} ${styles.label25}`}>25%</span>
                                    <span className={`${styles.percentageLabel} ${styles.label15}`}>15%</span>

                                </div>

                                <div className={styles.pieChartLegendSection}>

                                    <p className={styles.pieChartLegendSectionTitle}>

                                        Customer Feedback Sentiment Analysis

                                    </p>

                                    <div className={styles.pieChartLegends}>

                                        <div className={styles.pieChartLegend}>

                                            <div className={styles.positiveLegend}>

                                            </div>

                                            <p className={styles.pieChartLegendText}>

                                                Positive (60%)

                                            </p>

                                        </div>

                                        <div className={styles.pieChartLegend}>

                                            <div className={styles.neutralLegend}>

                                            </div>

                                            <p className={styles.pieChartLegendText}>

                                                Neutral (25%)

                                            </p>

                                        </div>

                                        <div className={styles.pieChartLegend}>

                                            <div className={styles.negativeLegend}>

                                            </div>

                                            <p className={styles.pieChartLegendText}>

                                                Negative (15%)

                                            </p>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div className={styles.actionPlanSection}>

                                <p className={styles.actionPlanSectionTitle}>

                                    AI-Generated Action Plan

                                </p>

                                <div className={styles.actionPlan}>

                                    <div className={styles.actionPlanIndexOne}>

                                        <p className={styles.actionPlanIndexText}>

                                            1

                                        </p>

                                    </div>

                                    <div className={styles.actionPlanContent}>

                                        <p className={styles.actionPlanContentTitle}>

                                            Phase 1 (Weeks 1 - 2)

                                        </p>

                                        <p className={styles.actionPlanContentDescription}>

                                            Implement feedback loop for negative customers.

                                        </p>

                                    </div>

                                </div>

                                <div className={styles.actionPlan}>

                                    <div className={styles.actionPlanIndexTwo}>

                                        <p className={styles.actionPlanIndexText}>

                                            2

                                        </p>

                                    </div>

                                    <div className={styles.actionPlanContent}>

                                        <p className={styles.actionPlanContentTitle}>

                                            Phase 2 (Weeks 3 - 6)

                                        </p>

                                        <p className={styles.actionPlanContentDescription}>

                                            Launch loyalty program for neutral/positive audience.

                                        </p>

                                    </div>

                                </div>

                                <div className={styles.actionPlan}>

                                    <div className={styles.actionPlanIndexThree}>

                                        <p className={styles.actionPlanIndexText}>

                                            3

                                        </p>

                                    </div>

                                    <div className={styles.actionPlanContent}>

                                        <p className={styles.actionPlanContentTitle}>

                                            Phase 3 (Weeks 7 - 8)

                                        </p>

                                        <p className={styles.actionPlanContentDescription}>

                                            Review outcomes and adjust strategy.

                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    )}



                </div>
            </div>

            <div className={styles.realWorldImpactSection}>
                {isMobile ? (
                    <>
                        <svg className={styles.realWorldImpactSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="227" height="2" viewBox="0 0 430 2" fill="none">
                            <path d="M1 1H429" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                        </svg>

                        <p className={styles.realWorldImpactTitle}>

                            REAL WORLD IMPACT

                        </p>

                        <p className={styles.rwiSectionDescription}>

                            See how our AI Solutions <span className={styles.highlightedText}> transform industries </span> and <span className={styles.highlightedText}> drive success </span>

                        </p>

                        <div className={styles.rwiIndustrySection}>

                            <img
                                className={styles.rwiIndustryImage}
                                src={industries[activeIndustryIndex].image}
                                alt={`Illustration of ${industries[activeIndustryIndex].title} industry`}
                            />

                            <div className={styles.rwiIndustryContentSection}>

                                <div className={styles.rwiIndustryTitleAndChevrons}>

                                    <p className={styles.rwiIndustryTitle}>

                                        {current.title}
                                    </p>

                                    <div className={styles.chevrons}>

                                        <button className={styles.leftChevron} onClick={goToPrevIndustry}>

                                            <svg className={styles.leftChevronIcon} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                                <path d="M39.5846 25H10.418" stroke="black" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M25.0013 39.5846L10.418 25.0013L25.0013 10.418" stroke="black" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                        </button>

                                        <button className={styles.rightChevron} onClick={goToNextIndustry}>

                                            <svg className={styles.rightChevronIcon} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                                <path d="M10.418 25H39.5846" stroke="#270949" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M25 10.4141L39.5833 24.9974L25 39.5807" stroke="#270949" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                        </button>

                                    </div>

                                </div>

                                <div className={styles.rwiIndustryDescriptionFrame}>

                                    <p className={styles.rwiIndustryDescription}>

                                        {current.description}

                                    </p>

                                </div>

                                <div className={styles.rwiIndustryKpi}>

                                    <div className={styles.rwiKpiTitleAndIcon}>

                                        <h4 className={styles.kpiTitle}>

                                            {current.kpiTitle}

                                        </h4>

                                        <div className={styles.kpiIconFrame}>

                                            {React.cloneElement(current.icon, {
                                                className: styles.kpiIcon
                                            })}

                                        </div>

                                    </div>

                                    <svg className={styles.rwiKpiValueIcon} xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
                                        <path d="M74.3477 75.5625H64.5977C63.9249 75.5625 63.3789 75.0141 63.3789 74.3438V42.6562C63.3789 41.9859 63.9249 41.4375 64.5977 41.4375C65.2704 41.4375 65.8164 41.9859 65.8164 42.6562V73.125H73.1289V20.7188C73.1289 20.0436 73.6749 19.5 74.3477 19.5C75.0204 19.5 75.5664 20.0436 75.5664 20.7188V74.3438C75.5664 75.0141 75.0204 75.5625 74.3477 75.5625Z" fill="black" />
                                        <path d="M53.6289 73.125H46.3164V67.0312C46.3164 66.3585 45.7704 65.8125 45.0977 65.8125C44.4249 65.8125 43.8789 66.3585 43.8789 67.0312V74.3438C43.8789 75.0141 44.4249 75.5625 45.0977 75.5625H54.8477C55.5204 75.5625 56.0664 75.0141 56.0664 74.3438V57.2812C56.0664 56.6085 55.5204 56.0625 54.8477 56.0625C54.1749 56.0625 53.6289 56.6085 53.6289 57.2812V73.125Z" fill="black" />
                                        <path d="M71.8945 73.125H3.64453C2.97178 73.125 2.42578 73.671 2.42578 74.3438C2.42578 75.0165 2.97178 75.5625 3.64453 75.5625H71.8945C72.5673 75.5625 73.1133 75.0165 73.1133 74.3438C73.1133 73.671 72.5697 73.125 71.8945 73.125Z" fill="black" />
                                        <path d="M25.5977 67.0312C24.9249 67.0312 24.3789 66.4828 24.3789 65.8125V40.2188C24.3789 39.5436 24.9249 39 25.5977 39H35.3477C36.0204 39 36.5664 39.5436 36.5664 40.2188V59.7188C36.5664 60.3891 36.0204 60.9375 35.3477 60.9375C34.6749 60.9375 34.1289 60.3891 34.1289 59.7188V41.4375H26.8164V65.8125C26.8164 66.4828 26.2704 67.0312 25.5977 67.0312Z" fill="black" />
                                        <path d="M6.09766 70.6875C5.42491 70.6875 4.87891 70.1391 4.87891 69.4688V49.9688C4.87891 49.2936 5.42491 48.75 6.09766 48.75H15.8477C16.5204 48.75 17.0664 49.2936 17.0664 49.9688V68.25C17.0664 68.9203 16.5204 69.4688 15.8477 69.4688C15.1749 69.4688 14.6289 68.9203 14.6289 68.25V51.1875H7.31641V69.4688C7.31641 70.1391 6.77041 70.6875 6.09766 70.6875Z" fill="black" />
                                        <path d="M45.0977 48.75C44.4249 48.75 43.8789 48.2064 43.8789 47.5312V30.4688C43.8789 29.7936 44.4249 29.25 45.0977 29.25H49.9727C50.6454 29.25 51.1914 29.7936 51.1914 30.4688C51.1914 31.1391 50.6454 31.6875 49.9727 31.6875H46.3164V47.5312C46.3164 48.2064 45.7704 48.75 45.0977 48.75Z" fill="black" />
                                        <path d="M8.53516 75.5655C7.86241 75.5655 7.31641 75.0195 7.31641 74.3467C7.31641 73.674 7.86241 73.128 8.53516 73.128C33.4001 73.128 53.6289 52.8992 53.6289 28.0343V21.9405H49.9727C49.5363 21.9405 49.1366 21.7089 48.9172 21.3336C48.7003 20.9582 48.6978 20.4926 48.9123 20.1172L58.6623 3.05475C59.1011 2.29425 60.3418 2.29425 60.7805 3.05475L70.5305 20.1172C70.745 20.4926 70.7426 20.9582 70.5257 21.3336C70.3087 21.7089 69.909 21.9405 69.4727 21.9405H65.8164V28.0343C65.8164 28.707 65.2704 29.253 64.5977 29.253C63.9249 29.253 63.3789 28.707 63.3789 28.0343V20.7218C63.3789 20.049 63.9249 19.503 64.5977 19.503H67.374L59.7227 6.11625L52.0713 19.503H54.8477C55.5204 19.503 56.0664 20.049 56.0664 20.7218V28.0343C56.0664 54.2423 34.7432 75.5655 8.53516 75.5655Z" fill="black" />
                                        <path d="M64.5977 34.125C65.2708 34.125 65.8164 33.5793 65.8164 32.9062C65.8164 32.2332 65.2708 31.6875 64.5977 31.6875C63.9246 31.6875 63.3789 32.2332 63.3789 32.9062C63.3789 33.5793 63.9246 34.125 64.5977 34.125Z" fill="black" />
                                    </svg>

                                    <p className={styles.rwiKpiDescription}>

                                        {current.kpiDescription}

                                    </p>

                                </div>
                            </div>

                        </div>

                    </>
                ) : (
                    <>
                        <svg className={styles.realWorldImpactSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="227" height="2" viewBox="0 0 430 2" fill="none">
                            <path d="M1 1H429" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                        </svg>

                        <p className={styles.realWorldImpactTitle}>

                            REAL WORLD IMPACT

                        </p>

                        <div className={styles.rwiSectionDescriptionAndChevrons}>

                            <p className={styles.rwiSectionDescription}>

                                See how our AI Solutions <span className={styles.highlightedText}> transform industries </span> and <span className={styles.highlightedText}> drive success </span>

                            </p>

                            <div className={styles.chevrons}>

                                <button className={styles.leftChevron} onClick={goToPrevIndustry}>

                                    <svg className={styles.leftChevronIcon} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <path d="M39.5846 25H10.418" stroke="black" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M25.0013 39.5846L10.418 25.0013L25.0013 10.418" stroke="black" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </button>

                                <button className={styles.rightChevron} onClick={goToNextIndustry}>

                                    <svg className={styles.rightChevronIcon} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <path d="M10.418 25H39.5846" stroke="#270949" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M25 10.4141L39.5833 24.9974L25 39.5807" stroke="#270949" stroke-width="4.16667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </button>

                            </div>
                        </div>

                        <div className={styles.rwiIndustrySection}>

                            <div className={styles.rwiIndustryContentSection}>

                                <h3 className={styles.rwiIndustryTitle}>

                                    {current.title}

                                </h3>

                                <div className={styles.rwiIndustryDescriptionFrame}>

                                    <p className={styles.rwiIndustryDescription}>

                                        {current.description}

                                    </p>

                                </div>

                                <div className={styles.rwiIndustryKpi}>

                                    <div className={styles.rwiKpiTitleAndIcon}>

                                        <h4 className={styles.kpiTitle}>

                                            {current.kpiTitle}

                                        </h4>

                                        <div className={styles.kpiIconFrame}>

                                            {current.icon}

                                        </div>

                                    </div>

                                    <svg className={styles.rwiKpiValueIcon} xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
                                        <path d="M74.3477 75.5625H64.5977C63.9249 75.5625 63.3789 75.0141 63.3789 74.3438V42.6562C63.3789 41.9859 63.9249 41.4375 64.5977 41.4375C65.2704 41.4375 65.8164 41.9859 65.8164 42.6562V73.125H73.1289V20.7188C73.1289 20.0436 73.6749 19.5 74.3477 19.5C75.0204 19.5 75.5664 20.0436 75.5664 20.7188V74.3438C75.5664 75.0141 75.0204 75.5625 74.3477 75.5625Z" fill="black" />
                                        <path d="M53.6289 73.125H46.3164V67.0312C46.3164 66.3585 45.7704 65.8125 45.0977 65.8125C44.4249 65.8125 43.8789 66.3585 43.8789 67.0312V74.3438C43.8789 75.0141 44.4249 75.5625 45.0977 75.5625H54.8477C55.5204 75.5625 56.0664 75.0141 56.0664 74.3438V57.2812C56.0664 56.6085 55.5204 56.0625 54.8477 56.0625C54.1749 56.0625 53.6289 56.6085 53.6289 57.2812V73.125Z" fill="black" />
                                        <path d="M71.8945 73.125H3.64453C2.97178 73.125 2.42578 73.671 2.42578 74.3438C2.42578 75.0165 2.97178 75.5625 3.64453 75.5625H71.8945C72.5673 75.5625 73.1133 75.0165 73.1133 74.3438C73.1133 73.671 72.5697 73.125 71.8945 73.125Z" fill="black" />
                                        <path d="M25.5977 67.0312C24.9249 67.0312 24.3789 66.4828 24.3789 65.8125V40.2188C24.3789 39.5436 24.9249 39 25.5977 39H35.3477C36.0204 39 36.5664 39.5436 36.5664 40.2188V59.7188C36.5664 60.3891 36.0204 60.9375 35.3477 60.9375C34.6749 60.9375 34.1289 60.3891 34.1289 59.7188V41.4375H26.8164V65.8125C26.8164 66.4828 26.2704 67.0312 25.5977 67.0312Z" fill="black" />
                                        <path d="M6.09766 70.6875C5.42491 70.6875 4.87891 70.1391 4.87891 69.4688V49.9688C4.87891 49.2936 5.42491 48.75 6.09766 48.75H15.8477C16.5204 48.75 17.0664 49.2936 17.0664 49.9688V68.25C17.0664 68.9203 16.5204 69.4688 15.8477 69.4688C15.1749 69.4688 14.6289 68.9203 14.6289 68.25V51.1875H7.31641V69.4688C7.31641 70.1391 6.77041 70.6875 6.09766 70.6875Z" fill="black" />
                                        <path d="M45.0977 48.75C44.4249 48.75 43.8789 48.2064 43.8789 47.5312V30.4688C43.8789 29.7936 44.4249 29.25 45.0977 29.25H49.9727C50.6454 29.25 51.1914 29.7936 51.1914 30.4688C51.1914 31.1391 50.6454 31.6875 49.9727 31.6875H46.3164V47.5312C46.3164 48.2064 45.7704 48.75 45.0977 48.75Z" fill="black" />
                                        <path d="M8.53516 75.5655C7.86241 75.5655 7.31641 75.0195 7.31641 74.3467C7.31641 73.674 7.86241 73.128 8.53516 73.128C33.4001 73.128 53.6289 52.8992 53.6289 28.0343V21.9405H49.9727C49.5363 21.9405 49.1366 21.7089 48.9172 21.3336C48.7003 20.9582 48.6978 20.4926 48.9123 20.1172L58.6623 3.05475C59.1011 2.29425 60.3418 2.29425 60.7805 3.05475L70.5305 20.1172C70.745 20.4926 70.7426 20.9582 70.5257 21.3336C70.3087 21.7089 69.909 21.9405 69.4727 21.9405H65.8164V28.0343C65.8164 28.707 65.2704 29.253 64.5977 29.253C63.9249 29.253 63.3789 28.707 63.3789 28.0343V20.7218C63.3789 20.049 63.9249 19.503 64.5977 19.503H67.374L59.7227 6.11625L52.0713 19.503H54.8477C55.5204 19.503 56.0664 20.049 56.0664 20.7218V28.0343C56.0664 54.2423 34.7432 75.5655 8.53516 75.5655Z" fill="black" />
                                        <path d="M64.5977 34.125C65.2708 34.125 65.8164 33.5793 65.8164 32.9062C65.8164 32.2332 65.2708 31.6875 64.5977 31.6875C63.9246 31.6875 63.3789 32.2332 63.3789 32.9062C63.3789 33.5793 63.9246 34.125 64.5977 34.125Z" fill="black" />
                                    </svg>


                                    <p className={styles.rwiKpiDescription}>

                                        {current.kpiDescription}

                                    </p>

                                </div>

                            </div>

                            <img
                                className={styles.rwiIndustryImage}
                                src={industries[activeIndustryIndex].image}
                                alt={`Illustration of ${industries[activeIndustryIndex].title} industry`}
                            />

                        </div>
                    </>
                )}
            </div>

            <div className={styles.whyAtirathSection}>

                {isMobile ? (
                    <>

                        <div className={styles.whyAtirathSection}>

                            <svg className = {styles.whyAtirathSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="178" height="2" viewBox="0 0 178 2" fill="none">
                                <path d="M1 1H177" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                            </svg>

                            <p className={styles.whyAtirathSectionTitle}>

                                WHY THEY PREFER ATIRATH

                            </p>

                            <p className={styles.whyAtirathSectionDescription}>

                                We are harnessing <span className = {styles.mobileHighlightedText}> cutting-edge AI research </span> to deliver optimized, scalable, and <span className = {styles.mobileHighlightedText}> intelligent solutions </span> for the <span className = {styles.mobileHighlightedText}> enterprises </span> of tomorrow.
                            </p>

                            <div className={styles.wasKpiSection}>

                                <div className={styles.wasKpi}>

                                    <p className={styles.wasKpiValue}>

                                        1K+
                                    </p>

                                    <p className={styles.wasKpiDescription}>

                                        Domain-specific conversations . used for fine-tuning
                                    </p>


                                </div>

                                <div className={styles.wasKpi}>

                                    <p className={styles.wasKpiValue}>

                                        300+
                                    </p>

                                    <p className={styles.wasKpiDescription}>

                                        Hours of multilingual Indic Data used for voice model fine-tuning
                                    </p>


                                </div>

                                <div className={styles.wasKpiThree}>

                                    <p className={styles.wasKpiThreeDescription}>

                                        Seamless Cloud Deployments
                                    </p>

                                    <div className={styles.wasKpiThreeValues}>

                                        <div className={styles.wasKpiThreeValue}>

                                            <svg className={styles.wasKpiThreeValueIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                                <g clip-path="url(#clip0_719_240)">
                                                    <path d="M23 13C18.3 13 14.5 16.8 14.5 21.5C14.5 26.2 18.3 30 23 30C27.7 30 31.5 26.2 31.5 21.5C31.5 16.8 27.7 13 23 13ZM29.5 21H26.5C26.5 19 26.2 17 25.6 15.5C27.7 16.5 29.3 18.5 29.5 21ZM23 28C22.6 27.8 21.7 26.2 21.5 23H24.4C24.2 26.2 23.4 27.8 23 28ZM21.5 21C21.6 17.2 22.6 15.2 22.9 15C23.3 15.2 24.3 17.2 24.4 21H21.5ZM20.4 15.5C19.8 17 19.6 19 19.5 21H16.5C16.7 18.5 18.3 16.5 20.4 15.5ZM16.7 23H19.5C19.6 24.6 19.9 26.2 20.4 27.5C18.6 26.7 17.2 25 16.7 23ZM25.6 27.5C26.1 26.2 26.4 24.7 26.5 23H29.4C28.8 25 27.4 26.7 25.6 27.5Z" fill="#3B5CC6" />
                                                    <path d="M26.3 10C25.4 5.4 21.3 2 16.5 2C11.7 2 7.6 5.4 6.7 10.1C3.2 10.8 0.5 13.8 0.5 17.5C0.5 21.6 3.9 25 8 25H11.5V23H8C5 23 2.5 20.5 2.5 17.5C2.5 14.6 4.7 12.2 7.6 12H8.5V11.1C9 7.1 12.4 4 16.5 4C20.2 4 23.3 6.6 24.2 10H26.3Z" fill="#3B5CC6" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_719_240">
                                                        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <p className={styles.wasKpiThreeValueTitle}>

                                                Public
                                            </p>

                                        </div>

                                        <div className={styles.wasKpiThreeValue}>

                                            <svg className={styles.wasKpiThreeValueIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                                <g clip-path="url(#clip0_719_245)">
                                                    <path d="M20.5 20V17C20.5 15.9391 20.0786 14.9217 19.3284 14.1716C18.5783 13.4214 17.5609 13 16.5 13C15.4391 13 14.4217 13.4214 13.6716 14.1716C12.9214 14.9217 12.5 15.9391 12.5 17V20C11.9698 20.0008 11.4616 20.2118 11.0867 20.5867C10.7118 20.9616 10.5008 21.4698 10.5 22V28C10.5008 28.5302 10.7118 29.0384 11.0867 29.4133C11.4616 29.7882 11.9698 29.9992 12.5 30H20.5C21.0302 29.9992 21.5384 29.7882 21.9133 29.4133C22.2882 29.0384 22.4992 28.5302 22.5 28V22C22.4992 21.4698 22.2882 20.9616 21.9133 20.5867C21.5384 20.2118 21.0302 20.0008 20.5 20ZM14.5 17C14.5 16.4696 14.7107 15.9609 15.0858 15.5858C15.4609 15.2107 15.9696 15 16.5 15C17.0304 15 17.5391 15.2107 17.9142 15.5858C18.2893 15.9609 18.5 16.4696 18.5 17V20H14.5V17ZM12.5 28V22H20.5L20.501 28H12.5Z" fill="#3B5CC6" />
                                                    <path d="M26.3301 10.1145C25.951 8.15029 24.9921 6.34473 23.577 4.93072C22.1619 3.51671 20.3556 2.55913 18.3911 2.1815C17.1007 1.93226 15.7737 1.93979 14.4861 2.20364C13.1986 2.4675 11.9756 2.98251 10.8872 3.71924C9.79874 4.45598 8.86617 5.39999 8.14276 6.49733C7.41935 7.59466 6.91928 8.82381 6.67114 10.1145C4.82771 10.4468 3.17527 11.4567 2.03874 12.9457C0.902204 14.4346 0.3638 16.2949 0.529385 18.1607C0.69497 20.0265 1.55257 21.7629 2.93355 23.0284C4.31454 24.2939 6.119 24.997 7.99214 24.9995H8.50114V22.9995H7.99614C6.62296 22.997 5.30036 22.4811 4.28816 21.5531C3.27596 20.6252 2.64734 19.3523 2.52579 17.9845C2.40425 16.6167 2.79857 15.2529 3.63129 14.161C4.46401 13.0691 5.67492 12.3281 7.02614 12.0835L8.37614 11.8385L8.63514 10.4935C8.98714 8.66552 9.96485 7.01721 11.4002 5.83185C12.8356 4.64649 14.6391 3.9981 16.5006 3.9981C18.3622 3.9981 20.1657 4.64649 21.601 5.83185C23.0364 7.01721 24.0141 8.66552 24.3661 10.4935L24.6251 11.8385L25.9741 12.0835C27.325 12.328 28.5356 13.0687 29.3683 14.16C30.201 15.2514 30.5957 16.6146 30.4748 17.982C30.3539 19.3495 29.7262 20.6223 28.7149 21.5506C27.7037 22.479 26.3819 22.9958 25.0091 22.9995H24.5011V24.9995H25.0091C26.8822 24.9968 28.6865 24.2935 30.0673 23.0279C31.4481 21.7623 32.3055 20.0259 32.471 18.1602C32.6364 16.2944 32.0979 14.4343 30.9614 12.9455C29.8249 11.4566 28.1725 10.4468 26.3291 10.1145" fill="#3B5CC6" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_719_245">
                                                        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <p className={styles.wasKpiThreeValueTitle}>

                                                Private
                                            </p>

                                        </div>

                                        <div className={styles.wasKpiThreeValue}>

                                            <svg className={styles.waskpiThreeValueIcon} xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                                                <path d="M8 23.636C5.79394 23.636 3.90933 22.8724 2.34618 21.3451C0.78303 19.8178 0.000969697 17.9512 0 15.7451C0 13.8542 0.569697 12.1693 1.70909 10.6906C2.84848 9.21177 4.33939 8.26631 6.18182 7.85419C6.78788 5.62389 8 3.81783 9.81818 2.43601C11.6364 1.05419 13.697 0.363281 16 0.363281C18.8364 0.363281 21.2427 1.3514 23.2189 3.32764C25.1952 5.30389 26.1828 7.70971 26.1818 10.5451C27.8545 10.739 29.2427 11.4605 30.3462 12.7095C31.4497 13.9584 32.001 15.4188 32 17.0906C32 18.9087 31.3639 20.4544 30.0916 21.7276C28.8194 23.0009 27.2737 23.637 25.4545 23.636H8ZM8 20.7269H25.4545C26.4727 20.7269 27.3333 20.3754 28.0364 19.6724C28.7394 18.9693 29.0909 18.1087 29.0909 17.0906C29.0909 16.0724 28.7394 15.2118 28.0364 14.5087C27.3333 13.8057 26.4727 13.4542 25.4545 13.4542H23.2727V10.5451C23.2727 8.53298 22.5634 6.81758 21.1447 5.39892C19.7261 3.98025 18.0112 3.2714 16 3.27237C13.9888 3.27334 12.2739 3.98267 10.8553 5.40037C9.43661 6.81807 8.72727 8.53298 8.72727 10.5451H8C6.59394 10.5451 5.39394 11.0421 4.4 12.036C3.40606 13.0299 2.90909 14.2299 2.90909 15.636C2.90909 17.0421 3.40606 18.2421 4.4 19.236C5.39394 20.2299 6.59394 20.7269 8 20.7269Z" fill="#3B5CC6" />
                                            </svg>

                                            <p className={styles.wasKpiThreeValueTitle}>

                                                Hybrid
                                            </p>

                                        </div>
                                    </div>




                                </div>
                            </div>
                        </div>


                    </>
                ) : (
                    <>
                        <svg className={styles.whyAtirathSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="293" height="2" viewBox="0 0 430 2" fill="none">
                            <path d="M1 1H429" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                        </svg>

                        <p className={styles.whyAtirathSectionTitle}>

                            WHY THEY PREFER ATIRATH

                        </p>

                        <p className={styles.whyAtirathSectionDescription}>

                            We are harnessing <span className={styles.highlightedText}> cutting-edge AI research </span> to deliver optimized, scalable, and intelligent
                            <span className={styles.highlightedText}> solutions </span> for the <span className={styles.highlightedText}> enterprises </span> of tomorrow.

                        </p>

                        <div className={styles.wasKpiSectionOne}>

                            <div className={styles.wasKpiOne}>

                                <p className={styles.wasKpiOneValue}>

                                    1K+

                                </p>

                                <p className={styles.wasKpiOneDescription}>

                                    Domain-specific conversations used for fine-tuning

                                </p>

                            </div>

                            <div className={styles.wasKpiTwo}>

                                <p className={styles.wasKpiTwoValue}>

                                    300+

                                </p>

                                <p className={styles.wasKpiTwoDescription}>

                                    Hours of multilingual Indic data used for voice model fine-tuning

                                </p>

                            </div>

                        </div>

                        <div className={styles.wasKpiSectionTwo}>

                            <div className={styles.wasResearchPageButtonFrame}>

                                <div className={styles.wasResearchPageDescriptionFrame}>

                                    <h3 className={styles.wasResearchPageDescription}>

                                        Explore our AI Research

                                    </h3>

                                </div>

                                <button className={styles.wasResearchPageOpenButton}>

                                    <svg className={styles.wasResearchPageOpenIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15 3H21V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 14L21 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </button>

                            </div>

                            <div className={styles.wasKpiThree}>

                                <p className={styles.wasKpiThreeDescription}>

                                    Seamless Cloud Deployments

                                </p>

                                <div className={styles.wasKpiThreeValues}>

                                    <div className={styles.wasKpiThreeValueOne}>

                                        <svg className={styles.wasKpiThreeValueOneIcon} xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 75 75" fill="none">
                                            <path d="M52.7344 30.4688C41.7188 30.4688 32.8125 39.375 32.8125 50.3906C32.8125 61.4062 41.7188 70.3125 52.7344 70.3125C63.75 70.3125 72.6562 61.4062 72.6562 50.3906C72.6562 39.375 63.75 30.4688 52.7344 30.4688ZM67.9688 49.2188H60.9375C60.9375 44.5312 60.2344 39.8438 58.8281 36.3281C63.75 38.6719 67.5 43.3594 67.9688 49.2188ZM52.7344 65.625C51.7969 65.1562 49.6875 61.4062 49.2188 53.9062H56.0156C55.5469 61.4062 53.6719 65.1562 52.7344 65.625ZM49.2188 49.2188C49.4531 40.3125 51.7969 35.625 52.5 35.1562C53.4375 35.625 55.7812 40.3125 56.0156 49.2188H49.2188ZM46.6406 36.3281C45.2344 39.8438 44.7656 44.5312 44.5312 49.2188H37.5C37.9688 43.3594 41.7187 38.6719 46.6406 36.3281ZM37.9688 53.9062H44.5312C44.7656 57.6562 45.4687 61.4062 46.6406 64.4531C42.4219 62.5781 39.1406 58.5938 37.9688 53.9062ZM58.8281 64.4531C60 61.4062 60.7031 57.8906 60.9375 53.9062H67.7344C66.3281 58.5938 63.0469 62.5781 58.8281 64.4531Z" fill="#3B5CC6" />
                                            <path d="M60.4688 23.4375C58.3594 12.6562 48.75 4.6875 37.5 4.6875C26.25 4.6875 16.6406 12.6563 14.5312 23.6719C6.32812 25.3125 0 32.3438 0 41.0156C0 50.625 7.96875 58.5938 17.5781 58.5938H25.7812V53.9062H17.5781C10.5469 53.9062 4.6875 48.0469 4.6875 41.0156C4.6875 34.2188 9.84375 28.5938 16.6406 28.125H18.75V26.0156C19.9219 16.6406 27.8906 9.375 37.5 9.375C46.1719 9.375 53.4375 15.4688 55.5469 23.4375H60.4688Z" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.wasKpiThreeValueOneTitle}>

                                            Public

                                        </p>

                                    </div>

                                    <div className={styles.wasKpiThreeValueTwo}>

                                        <svg className={styles.wasKpiThreeValueTwoIcon} xmlns="http://www.w3.org/2000/svg" width="76" height="75" viewBox="0 0 76 75" fill="none">
                                            <g clip-path="url(#clip0_462_195)">
                                                <path d="M47.375 46.875V39.8438C47.375 37.3573 46.3873 34.9728 44.6291 33.2146C42.871 31.4565 40.4864 30.4688 38 30.4688C35.5136 30.4688 33.129 31.4565 31.3709 33.2146C29.6127 34.9728 28.625 37.3573 28.625 39.8438V46.875C27.3824 46.8769 26.1912 47.3713 25.3125 48.25C24.4338 49.1287 23.9394 50.3199 23.9375 51.5625V65.625C23.9394 66.8676 24.4338 68.0588 25.3125 68.9375C26.1912 69.8162 27.3824 70.3106 28.625 70.3125H47.375C48.6176 70.3106 49.8088 69.8162 50.6875 68.9375C51.5662 68.0588 52.0606 66.8676 52.0625 65.625V51.5625C52.0606 50.3199 51.5662 49.1287 50.6875 48.25C49.8088 47.3713 48.6176 46.8769 47.375 46.875ZM33.3125 39.8438C33.3125 38.6005 33.8064 37.4083 34.6854 36.5292C35.5645 35.6501 36.7568 35.1562 38 35.1562C39.2432 35.1562 40.4355 35.6501 41.3146 36.5292C42.1936 37.4083 42.6875 38.6005 42.6875 39.8438V46.875H33.3125V39.8438ZM28.625 65.625V51.5625H47.375L47.3773 65.625H28.625Z" fill="#3B5CC6" />
                                                <path d="M61.0394 23.7059C60.1509 19.1022 57.9033 14.8704 54.5867 11.5564C51.2702 8.24229 47.0367 5.99796 42.4324 5.11289C39.4078 4.52874 36.2978 4.54637 33.28 5.16478C30.2623 5.78319 27.396 6.99025 24.8449 8.71698C22.2939 10.4437 20.1082 12.6562 18.4127 15.2281C16.7172 17.8 15.5452 20.6808 14.9636 23.7059C10.6431 24.4847 6.77017 26.8517 4.10642 30.3414C1.44267 33.8311 0.18078 38.1911 0.568871 42.5641C0.956962 46.9371 2.96695 51.0067 6.20364 53.9728C9.44032 56.9389 13.6695 58.5868 18.0597 58.5926H19.2527V53.9051H18.0691C14.8507 53.8992 11.7508 52.6901 9.37849 50.5152C7.00615 48.3403 5.53282 45.3569 5.24795 42.1512C4.96309 38.9454 5.88728 35.749 7.83896 33.1899C9.79064 30.6308 12.6287 28.894 15.7957 28.3207L18.9597 27.7465L19.5667 24.5941C20.3917 20.3098 22.6832 16.4466 26.0474 13.6684C29.4116 10.8902 33.6385 9.37055 38.0015 9.37055C42.3646 9.37055 46.5914 10.8902 49.9556 13.6684C53.3198 16.4466 55.6113 20.3098 56.4363 24.5941L57.0433 27.7465L60.205 28.3207C63.371 28.8938 66.2084 30.6297 68.16 33.1875C70.1117 35.7454 71.0367 38.9405 70.7534 42.1454C70.4701 45.3503 68.9989 48.3335 66.6288 50.5093C64.2586 52.6851 61.1607 53.8963 57.9433 53.9051H56.7527V58.5926H57.9433C62.3333 58.5862 66.5621 56.9379 69.7983 53.9716C73.0346 51.0054 75.0441 46.9358 75.4319 42.5629C75.8197 38.1901 74.5577 33.8304 71.8939 30.3409C69.2302 26.8514 65.3574 24.4847 61.0371 23.7059" fill="#3B5CC6" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_462_195">
                                                    <rect width="75" height="75" fill="white" transform="translate(0.5)" />
                                                </clipPath>
                                            </defs>
                                        </svg>

                                        <p className={styles.wasKpiThreeValueTwoTitle}>

                                            Private

                                        </p>

                                    </div>

                                    <div className={styles.wasKpiThreeValueThree}>

                                        <svg className={styles.waskpiThreeValueThreeIcon} xmlns="http://www.w3.org/2000/svg" width="75" height="55" viewBox="0 0 75 55" fill="none">
                                            <path d="M18.75 54.9986C13.5795 54.9986 9.1625 53.2088 5.49886 49.6293C1.83523 46.0497 0.00227273 41.6747 0 36.5043C0 32.0724 1.33523 28.1236 4.00568 24.6577C6.67614 21.1918 10.1705 18.9759 14.4886 18.0099C15.9091 12.7827 18.75 8.54972 23.0114 5.31108C27.2727 2.07244 32.1023 0.453125 37.5 0.453125C44.1477 0.453125 49.7875 2.76903 54.4193 7.40085C59.0511 12.0327 61.3659 17.6713 61.3636 24.3168C65.2841 24.7713 68.5375 26.4622 71.1239 29.3895C73.7102 32.3168 75.0023 35.7395 75 39.6577C75 43.919 73.5091 47.5418 70.5273 50.5258C67.5455 53.5099 63.9227 55.0009 59.6591 54.9986H18.75ZM18.75 48.1804H59.6591C62.0455 48.1804 64.0625 47.3565 65.7102 45.7088C67.358 44.0611 68.1818 42.044 68.1818 39.6577C68.1818 37.2713 67.358 35.2543 65.7102 33.6065C64.0625 31.9588 62.0455 31.1349 59.6591 31.1349H54.5455V24.3168C54.5455 19.6009 52.883 15.5804 49.558 12.2554C46.233 8.9304 42.2136 7.26903 37.5 7.27131C32.7864 7.27358 28.767 8.93608 25.442 12.2588C22.117 15.5815 20.4545 19.6009 20.4545 24.3168H18.75C15.4545 24.3168 12.642 25.4815 10.3125 27.8111C7.98295 30.1406 6.81818 32.9531 6.81818 36.2486C6.81818 39.544 7.98295 42.3565 10.3125 44.6861C12.642 47.0156 15.4545 48.1804 18.75 48.1804Z" fill="#3B5CC6" />
                                        </svg>

                                        <p className={styles.wasKpiThreeValueThreeTitle}>

                                            Hybrid

                                        </p>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </>
                )}



            </div>

            <div className={styles.scheduleAMeetingSection}>

                <svg className={styles.scheduleAMeetingSectionStarterLine} xmlns="http://www.w3.org/2000/svg" width="236" height="2" viewBox="0 0 430 2" fill="none">
                    <path d="M1 1H429" stroke="#270949" stroke-width="2" stroke-linecap="round" />
                </svg>

                <p className={styles.scheduleAMeetingSectionTitle}>

                    SCHEDULE A MEETING

                </p>

                <div className={styles.scheduleAMeetingContentHouser}>

                    <div className={styles.samContactInformationSection}>

                        <div className={styles.chatWithUsSection}>

                            <div className={styles.chatWithUsIconFrame}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                    <path d="M22.75 12.4584C22.7537 13.8882 22.4197 15.2987 21.775 16.575C21.0106 18.1044 19.8356 19.3908 18.3814 20.2901C16.9272 21.1894 15.2514 21.666 13.5417 21.6667C12.1118 21.6704 10.7013 21.3364 9.425 20.6917L3.25 22.75L5.30833 16.575C4.66368 15.2987 4.32961 13.8882 4.33333 12.4584C4.33399 10.7486 4.81066 9.07279 5.70995 7.61863C6.60923 6.16447 7.89561 4.9894 9.425 4.22503C10.7013 3.58037 12.1118 3.2463 13.5417 3.25003H14.0833C16.3414 3.37461 18.4741 4.32769 20.0732 5.92679C21.6723 7.5259 22.6254 9.65865 22.75 11.9167V12.4584Z" stroke="#270949" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>

                            <div className={styles.chatWithUsInformationSection}>

                                <p className={styles.chatWithUsTitle}>

                                    Chat with us

                                </p>

                                <p className={styles.chatWithUsDescription}>

                                    Our team is always here to help

                                </p>

                                <p className={styles.chatWithUsEmail}>

                                    info@atirath.com

                                </p>

                            </div>

                        </div>

                        <div className={styles.visitUsSection}>

                            <div className={styles.visitUsIconFrame}>

                                <svg className={styles.visitUsIcon} xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                                    <g clip-path="url(#clip0_512_26)">
                                        <path d="M22.75 11.1641C22.75 18.7474 13 25.2474 13 25.2474C13 25.2474 3.25 18.7474 3.25 11.1641C3.25 8.5782 4.27723 6.09825 6.10571 4.26977C7.93419 2.44129 10.4141 1.41406 13 1.41406C15.5859 1.41406 18.0658 2.44129 19.8943 4.26977C21.7228 6.09825 22.75 8.5782 22.75 11.1641Z" stroke="#270949" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13 14.4141C14.7949 14.4141 16.25 12.959 16.25 11.1641C16.25 9.36914 14.7949 7.91406 13 7.91406C11.2051 7.91406 9.75 9.36914 9.75 11.1641C9.75 12.959 11.2051 14.4141 13 14.4141Z" stroke="#270949" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_512_26">
                                            <rect width="26" height="26" fill="white" transform="translate(0 0.332031)" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>

                            <div className={styles.visitUsInformationSection}>

                                <p className={styles.visitUsTitle}>

                                    Visit us

                                </p>

                                <p className={styles.visitUsDescription}>

                                    Come say hello to us at our HQ

                                </p>

                                <p className={styles.visitUsAddress}>

                                    Atirath Technologies, ILabs, Hyderabad, India

                                </p>

                            </div>

                        </div>

                    </div>

                    <div className={styles.samContactUsSection} ref={contactRef}>

                        <div className={styles.contactUsInformationAndFields}>

                            <div className={styles.contactUsTitleAndDescription}>

                                <h2 className={styles.contactUsTitle}>

                                    Have a challenge your company needs solved?

                                </h2>

                                <p className={styles.contactUsDescription}>

                                    We’re here to build AI-driven solutions that transform your enterprise and deliver results.

                                </p>
                            </div>

                            <div className={styles.contactUsFields}>

                                <input
                                    className={styles.nameField}
                                    type="text"
                                    name="name"
                                    placeholder="Your name"
                                    value={formData.name}
                                    onChange={handleChange}


                                />

                                <input
                                    className={styles.emailField}
                                    type="email"
                                    name="email"
                                    placeholder="Your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />

                                <textarea
                                    className={styles.companyChallengeField}
                                    name="feedback"
                                    rows="4"
                                    placeholder="Tell us a bit about your company’s challenge"
                                    value={formData.feedback}
                                    onChange={handleChange}
                                />

                            </div>

                        </div>

                        <div className={styles.contactUsButtonWrapper}>


                            <svg className={styles.contactUsButtonBackground} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 295 56" fill="none" preserveAspectRatio="none">
                                <path d="M0 10C0 4.47715 4.47715 0 10 0H284.755C292.651 0 297.432 8.72333 293.184 15.38L270.207 51.38C268.371 54.258 265.192 56 261.778 56H10C4.47716 56 0 51.5228 0 46V10Z" fill="#270949" />
                            </svg>

                            <button className={styles.contactUsScheduleMeetingButton} onClick={handleSubmit}>

                                <span className={styles.SMBText}> Schedule a Meeting </span>

                                <svg className={styles.SMBArrow} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 5L19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </button>

                        </div>

                    </div>

                </div>
            </div>




        </div>
    );
};

export default HomePage;
